/**
 * Кто в «Команде» смотрит, а кто меняет (§2 ТЗ портала).
 *
 * «Команда — владелец; просмотр — управляющий». Раздел один и тот же, и
 * разница ровно в одном: у управляющего все переключатели, галочки и
 * кнопки выключены, а денежного блока нет вовсе.
 *
 * Признак едет контекстом, а не через пять уровней свойств: блоков в
 * карточке шесть, и каждый пришлось бы прошивать вручную — забытый
 * означал бы включённую кнопку, которая на сервере всё равно откажет, но
 * человеку уже пообещала.
 *
 * **Это удобство, а не защита.** Право менять проверяет сервер на каждом
 * запросе: адреса-действия `access.py` закрыты `require_host_web`, и
 * выключенная здесь кнопка ничего к этому не добавляет.
 */

import { createContext, useContext } from 'react';

export const MayEditTeam = createContext(false);

export function useMayEditTeam(): boolean {
  return useContext(MayEditTeam);
}

/** Пояснение управляющему — одно на раздел, а не у каждой кнопки. */
export const VIEW_ONLY_TEXT =
  'Вы смотрите команду. Менять должности, входы и права может владелец системы.';
